import * as React from 'react'
import {StagePanel} from '../../../commons/components/stage/StagePanel'
import backgroundImage from './digitalStage.jpg'

export const DigitalStage: React.FC = ({children}) => (
  <StagePanel backgroundImage={backgroundImage}>{children}</StagePanel>
)
